<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <el-upload
      class="upload-demo"
      :action="url + '/zkfz/elZyVideoSection/importExamsQuest'"
      :on-change="handleChange"
      :limit="2"
      :before-upload="beforeUpload"
      :file-list="fileList"
    >
      <el-button size="small" type="primary">点击上传</el-button>
      <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
    </el-upload>

    <span
      slot="footer"
      class="dialog-footer"
      style="display: inline-block; width: 100%; text-align: center"
    >
      <el-button type="primary" @click="keepAdd">导入</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/courseware/checkCourseware'
import * as api2 from '@/api/courseStructure/courseStructure'
export default {
  name: 'KnowledgeInser',
  components: {},
  props: ['userType'],
  inject: ['reload'],
  data() {
    return {
      courseId: this.$route.query.id,
      courseWareId: '',
      loading: false,
      dialogVisible: false,
      fileList: [],
      file: '',
      institutionId: '',
    }
  },
  methods: {
    getCourseWareId() {
      api2.getCourseId({ courseId: this.courseId }).then(({ data }) => {
        this.courseWareId = data
      })
    },

    // 初始化
    init() {
      this.dialogVisible = true
    },

    handleChange(file, fileList) {
      this.file = file.raw
      if (fileList.length > 2) {
        fileList.splice(0, 1)
      }
    },
    // 上传文件之前
    beforeUpload(file) {
      const isJPG =
        file.type ==
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const isJPG1 = file.type == 'application/vnd.ms-excel'
      if (!isJPG && !isJPG1) {
        this.$message.error('上传文件只能是 xls/xlsx 类型!')
      }

      return isJPG || isJPG1
    },
    // 获取数据
    getList() {
      this.getSchoolByUid()
    },

    handleClose() {
      this.dialogVisible = false
      this.$emit('closeCourseExamsQuestInsertDialog')
    },

    keepAdd() {
      let formdata = new FormData()
      formdata.append('file', this.file)
      formdata.append('courseWareId', this.courseWareId)
      api.importExamsQuest(formdata).then(({ data }) => {
        if (data.code == 100000) {
          // data = data.data
          this.$message({ type: 'success', message: '导入成功' })
          this.dialogVisible = false
          this.reload()
        } else {
          this.$message({ type: 'error', message: data.msg })
        }
      })
    },

    getSchoolByUid() {
      api.getSchoolByUid(this.getUId).then(({ data }) => {
        if (data.code == 100000) {
          data = data.data
          this.institutionId = data.id
        }
      })
    },
  },
  created() {
    this.getList()
    this.getCourseWareId()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') || '4'
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
}
</script>

<style lang="scss" scoped>
</style>